import { Routes, Route, Navigate, useParams } from "react-router";
import { RequireAuth } from "./lib/auth";
import { AppLayout } from "./components/layout/AppLayout";
import { Dashboard } from "./routes/Dashboard";
import { Inicio } from "./routes/Inicio";
import { Agenda } from "./routes/Agenda";
import { Patients } from "./routes/Patients";
import { PatientDetail } from "./routes/PatientDetail";
import { FichaEmOutraClinica } from "./routes/FichaEmOutraClinica";
import { Protese } from "./routes/Protese";
import { MinhaConta } from "./routes/MinhaConta";
import { Configuracoes } from "./routes/Configuracoes";
import { Placeholder } from "./routes/Placeholder";
import { AppsPro } from "./routes/AppsPro";
import { Menu } from "./routes/Menu";
import { LabCadastros } from "./routes/LabCadastros";
import { CadastroPerfil } from "./routes/CadastroPerfil";
import { LabCatalogo } from "./routes/LabCatalogo";
import { CatalogoHub } from "./routes/CatalogoHub";
import { CatalogoVisualizar } from "./routes/CatalogoVisualizar";
import { LabComecar } from "./routes/LabComecar";
import { Procedimentos } from "./routes/Procedimentos";
import { Financeiro } from "./routes/Financeiro";
import { Salas } from "./routes/Salas";
import { MinhaClinica } from "./routes/MinhaClinica";
import { EditorDaPlanta } from "./routes/EditorDaPlanta";
import { Recepcao } from "./routes/Recepcao";
import { ExtratoVisualizar } from "./routes/ExtratoVisualizar";
import { Producao } from "./routes/Producao";
import { Estoque } from "./routes/Estoque";
import { Pedidos } from "./routes/Pedidos";
import { Notifications } from "./routes/Notifications";
import { Team } from "./routes/Team";
import { Organizations } from "./routes/Organizations";
import { Arquivos } from "./routes/Arquivos";
import { SharedFile } from "./routes/SharedFile";
import { VerComoEncerrado } from "./routes/VerComoEncerrado";
import { NotFound } from "./routes/NotFound";

export default function App() {
  return (
    <Routes>
      {/* Pública — quem recebeu um link de compartilhamento pode não ter conta na plataforma. */}
      <Route path="/compartilhado/:token" element={<SharedFile />} />
      <Route path="/ver-como/encerrado" element={<VerComoEncerrado />} />
      {/* Monitor do balcão: tela cheia, sem menu nem barra. */}
      <Route path="/salas/recepcao" element={<RequireAuth><Recepcao /></RequireAuth>} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/inicio" replace />} />

        {/* Clínica */}
        {/* "Dashboard" (legado) fica oculto do menu por enquanto, mas a rota continua acessível
         *  por link direto — só "Início" é o ponto de entrada padrão agora. */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/inicio" element={<Inicio />} />
        {/* URL antiga (retrocompat) */}
        <Route path="/dashboard-2" element={<Navigate to="/inicio" replace />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/clinica" element={<MinhaClinica />} />
        <Route path="/salas" element={<Salas />} />
        <Route path="/salas/planta" element={<EditorDaPlanta />} />
        <Route path="/pacientes" element={<Patients />} />
        <Route path="/pacientes/:id" element={<PatientDetail />} />
        <Route path="/pacientes/em/:organizacaoId/:id" element={<FichaEmOutraClinica />} />
        <Route path="/protese" element={<Protese />} />
        <Route path="/procedimentos" element={<Procedimentos />} />
        {/* A página da clínica se chamava "Serviços" — link salvo continua funcionando. */}
        <Route path="/servicos" element={<Navigate to="/procedimentos" replace />} />
        <Route path="/prontuario" element={<Placeholder title="Prontuário" />} />
        <Route path="/receituario" element={<Placeholder title="Receituário" />} />
        <Route path="/exames" element={<Placeholder title="Exames" />} />
        <Route path="/arquivos" element={<Arquivos />} />

        {/* Laboratório */}
        <Route path="/lab/cadastros" element={<LabCadastros />} />
        <Route path="/lab/cadastros/:id" element={<CadastroPerfil />} />
        <Route path="/lab/cadastros/:id/extrato" element={<ExtratoParaAba />} />
        <Route path="/lab/catalogo" element={<CatalogoHub />} />
        <Route path="/lab/comecar" element={<LabComecar />} />
        {/* O passo de procedimentos da clínica saiu (os das especialidades entram sozinhos). */}
        <Route path="/clinica/comecar" element={<Navigate to="/inicio" replace />} />
        <Route path="/lab/catalogo/gerenciar" element={<LabCatalogo />} />
        <Route path="/lab/catalogo/visualizar" element={<CatalogoVisualizar />} />
        <Route path="/lab/estoque" element={<Estoque />} />
        <Route path="/lab/producao" element={<Producao />} />
        <Route path="/lab/pedidos" element={<Pedidos />} />
        <Route path="/lab/arquivos" element={<Arquivos />} />
        {/* URLs antigas (retrocompat) — redirecionam pros novos */}
        <Route path="/lab/dentistas" element={<Navigate to="/lab/cadastros" replace />} />
        <Route path="/lab/casos" element={<Navigate to="/lab/producao" replace />} />
        <Route path="/lab/servicos" element={<Navigate to="/procedimentos" replace />} />
        <Route path="/lab/aceite-pedidos" element={<Navigate to="/lab/pedidos" replace />} />

        {/* Radiologia */}
        <Route path="/radio/dentistas" element={<Placeholder title="Dentistas (Radiologia)" />} />
        <Route path="/radio/exames" element={<Placeholder title="Exames (Radiologia)" />} />

        {/* Gestão */}
        <Route path="/financeiro" element={<Financeiro />} />
        <Route path="/financeiro/extratos/:id" element={<ExtratoVisualizar />} />

        {/* Equipe (organização de equipe) / Organizações (conta pessoal) */}
        <Route path="/equipe" element={<Team />} />
        <Route path="/organizacoes" element={<Organizations />} />

        {/* Apps Pro — marketplace de aplicativos profissionais */}
        <Route path="/apps-pro" element={<AppsPro />} />
        <Route path="/menu" element={<Menu />} />

        {/* Notificações */}
        <Route path="/notificacoes" element={<Notifications />} />

        {/* Minha conta (o que é da pessoa) e Configurações (da organização), cada uma com seções
            na URL. Os endereços antigos redirecionam — links salvos e notificações já enviadas. */}
        <Route path="/conta" element={<MinhaConta />} />
        <Route path="/conta/:secao" element={<MinhaConta />} />
        <Route path="/configuracoes" element={<Configuracoes />} />
        <Route path="/configuracoes/:secao" element={<Configuracoes />} />
        <Route path="/perfil" element={<Navigate to="/conta/perfil" replace />} />
        <Route path="/configuracoes/notificacoes" element={<Navigate to="/conta/preferencias" replace />} />
        <Route path="/configuracoes/layout" element={<Navigate to="/conta/preferencias" replace />} />
        <Route path="/configuracoes/organizacao" element={<Navigate to="/configuracoes/dados" replace />} />
        <Route path="/configuracoes/organizacoes" element={<Navigate to="/configuracoes/dados" replace />} />
        <Route path="/configuracoes/equipe" element={<Navigate to="/configuracoes/permissoes" replace />} />
        <Route path="/configuracoes/clinica" element={<Navigate to="/configuracoes/dados" replace />} />
        <Route path="/configuracoes/laboratorio" element={<Navigate to="/configuracoes/perfil-publico" replace />} />

        {/* Rotas legadas mantidas pra retrocompat de links antigos */}
        <Route path="/whatsapp" element={<Placeholder title="WhatsApp" />} />
        <Route path="/fotos" element={<Placeholder title="Fotografias" />} />
        <Route path="/modelos-3d" element={<Placeholder title="Modelos 3D" />} />
        <Route path="/academico" element={<Placeholder title="Casos e trilhas" />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/** O link antigo do extrato do cadastro abre a aba Extrato do perfil. */
function ExtratoParaAba() {
  const { id = "" } = useParams();
  return <Navigate to={`/lab/cadastros/${id}?aba=extrato`} replace />;
}
